import React from 'react';
import Logo from 'assets/images/wholesaler/logo/logo.svg';
const Header = () => {
  return (
    <>
      <div className=" bg-white w-full px-4 py-3 flex justify-between">
        <div className="flex">
          <img src={Logo} alt="logo" />
        </div>
        <span className="icon-notification text-2xl text-gray-6"></span>
      </div>
    </>
  );
};

export default Header;
